import { useCallback } from 'react';
import { fetchRepairServices } from '../utils/api';
import { useFetch } from './use-fetch';
import type { RepairBookingSession } from '../models/repair-bookings';

const useRepairOptions = (session: RepairBookingSession, productId: number) => {
    const fetcher = useCallback(() => {
        return fetchRepairServices(session.csrfToken, session.sessionId, productId);
    }, [session, productId]);

    const { data, error, loading } = useFetch(fetcher);

    return { services: data?.services ?? [], error, loading };
};

export default useRepairOptions;
